import { useFeatureFlagEnabled } from "@posthog/react";

import { DASHBOARD_FEED_FLAG_KEY } from "../lib/feature-flags";
import { useConsumerMarketplaceEnabled } from "./useConsumerMarketplaceEnabled";

export function useDashboardShellCapabilities() {
  return {
    feedEnabled: useFeatureFlagEnabled(DASHBOARD_FEED_FLAG_KEY) === true,
    // SILL-504: one launch gate for every sidebar marketplace item (Browse
    // agents + Your Offers), same flag that gates the marketplace routes.
    // Messaging (D19) is NOT surfaced here — the sidebar Messages item and
    // header icon call useMessagingEnabled() directly (see DashboardPage).
    marketplaceEnabled: useConsumerMarketplaceEnabled(),
  };
}
